import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import {Group, Shape} from "react-konva";
import {InchUtility} from "../../../lib/pipe-dataset";
import FlowArrowComponent from "./flow-arrow-component";


class ManifoldLegComponent extends Component {

  renderLegShape = () => {
    const imgUrl = require('../../../media/pipes/PIPE_PITCH_180x48.png');
    const fragmentImg = new window.Image();
    fragmentImg.src = imgUrl;
    const fillPatternScale = this.props.pipeOD / 180;

    return <Shape
      sceneFunc={(context, shape) => {
        context.beginPath();
        context.moveTo(0, this.props.pipeOD);
        context.lineTo((this.props.pipeOD / 2), this.props.pipeOD / 2);
        context.lineTo(this.props.pipeOD, this.props.pipeOD);
        context.lineTo(this.props.pipeOD, this.props.manifoldRowHeight);
        context.lineTo(0, this.props.manifoldRowHeight);
        context.lineTo(0, this.props.pipeOD);
        context.closePath();
        context.fillStrokeShape(shape);
      }}
      fillPatternImage={fragmentImg}
      fillPatternScaleX={fillPatternScale}
      fillPatternScaleY={fillPatternScale}
    />
  };

  renderVShape = () => {
    return <Shape
      sceneFunc={(context, shape) => {
        context.beginPath();
        context.moveTo(0, this.props.pipeOD);
        context.lineTo((this.props.pipeOD / 2), this.props.pipeOD / 2);
        context.lineTo(this.props.pipeOD, this.props.pipeOD);
        context.fillStrokeShape(shape);
      }}
      stroke="grey"
      strokeWidth={0.5}
    />
  };

  render() {
    return (
      <Group
        x={this.props.x}
        y={this.props.y}
        width={this.props.pipeOD}
        height={this.props.manifoldRowHeight}
        rotation={this.props.rotation | 0}
      >
        {this.renderLegShape()}
        {this.renderVShape()}
        <FlowArrowComponent arrowOrientation={this.props.arrowOrientation.vertical} y={this.props.manifoldRowHeight - this.props.pipeOD}/>
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    //...
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
    manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px,
  };
};

export default connect(
  mapStateToProps, {
    //...
  }
)(ManifoldLegComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/manifold-tee-leg-component.js